import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contactus',
    templateUrl: './contactus.component.html',
    styleUrls: ['./contactus.component.css'],
    standalone: false
})
export class ContactusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
